import { SetStateAction, Dispatch, createContext, useContext } from "react";

import { usePopoverLegacy } from "./usePopoverLegacy";
import { ThemeProviderContextProps } from "../../providers";

export type PopoverLegacyContextType =
  | (ReturnType<typeof usePopoverLegacy> & {
      setLabelId: Dispatch<SetStateAction<string | undefined>>;
      setDescriptionId: Dispatch<SetStateAction<string | undefined>>;
      theme?: ThemeProviderContextProps["theme"];
      mode?: ThemeProviderContextProps["mode"];
    })
  | null;

export const PopoverLegacyContext =
  createContext<PopoverLegacyContextType>(null);

export const usePopoverLegacyContext = () => {
  const context = useContext(PopoverLegacyContext);

  if (context == null) {
    throw new Error("Popover components must be wrapped in <Popover />");
  }

  return context;
};
